import styled from 'styled-components';
import { Row, Col, Radio } from 'antd';
import { Title as AntdTitle } from '@/components/Typography';
import { DEFAULT_RISK_RPN_COLOR } from '@/utils/constants';

export const ScoresContainer = styled(Row)`
	border-radius: 6px;
	border: 1px solid #d9d9d9;
	.ant-col {
		display: flex;
		justify-content: center;
	}
`;

export const RadioGroup = styled(Radio.Group)`
	width: 100%;
	border-radius: 6px !important;
	display: flex;
	justify-content: right;
	align-items: center;
	width: 100%;
	font-size: 18px;
	flex-direction: row;
	min-width: 60px;

	.ant-radio-button-wrapper {
		min-width: 40px;
		display: flex;
		justify-content: center;
		align-items: center;
		width: 100%;
		border: none;
		padding: 10px 0;
		font-size: 18px;
	}
	.ant-radio-button-wrapper-checked {
		color: #ffffff !important;
	}
	.ant-radio-button-checked {
		border: none !important;
		background-color: ${DEFAULT_RISK_RPN_COLOR};
		border-radius: 4px !important;
	}
	.ant-radio-button-wrapper-checked:not(:first-child)::before,
	.ant-radio-button-wrapper-checked:not(:last-child)::after {
		display: none !important;
	}
`;

export const Label = styled(Col)`
	display: flex;
	justify-content: flex-end;
`;

export const StyledTitle = styled(AntdTitle)`
	margin-top: 10px;
	text-align: right;
	position: relative;
	margin-right: 20px;
	white-space: nowrap;
`;

export const TooltipContainer = styled.div`
	top: 5px;
	right: 7px;
	position: absolute;
`;
